import script from "./WalletConnectBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./WalletConnectBtn.vue?vue&type=script&lang=ts&setup=true"

import "./WalletConnectBtn.vue?vue&type=style&index=0&id=e82ed160&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e82ed160"]])

export default __exports__